<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <div class="newsDetailPage" v-else-if="detail.type === 'article'">
      <div class="previewInfo" :class="{scrolled: scrolled}" v-if="detail.status !== 'published'">
        <img src="../assets/private.png">
        This is preview content, not available for public viewer.
      </div>
      <div class="newsHeader" v-if="detail.thumb"
        :style="{'background-image': `url(${detail.thumbHd})`}"></div>
      <!-- <div class="newsHeader noImg" v-else></div> -->
      <div class="cnt cntArticle">
        <div class="supportCnt">
          <div class="supportInfo">
            <h2>{{detail.title}}</h2>
            <div class="timestampCnt">
              <div class="category" v-if="detail.parent">{{detail.parent.name}}</div>
              <div class="timestamp">{{detail.publishDate | moment('dddd, DD MMMM YYYY')}}</div>
              <div class="reading-time">
                <span class="reading-time__label"></span>
                <span class="reading-time__duration"></span>
                <span class="reading-time__word-count"></span>
              </div>
            </div>
            <article class="articleDetail articleContent detail-wrapper"
              v-html="detail.content"></article>
            <div class="attachmentCnt" v-if="detail.attachments.length > 0">
              <h4 class="aTitle">Attachment</h4>
              <a :href="att.uri" target="_blank" class="attachmentItem"
                v-for="(att, i) in detail.attachments" :key="`att${i}`">
                <div class="attachmentIcon" v-if="att.type === 'image'"
                  :style="{'background-image': `url(${att.imageTh})`}"
                  :class="att.type"></div>
                <div class="attachmentIcon" v-else-if="att.type === 'video'"
                  :style="{'background-image': `url(${att.mainThumb})`}"
                  :class="att.type"></div>
                <div class="attachmentIcon" v-else :class="att.type"></div>
                <h4>{{att.name}}</h4>
                <div class="aIcon download"></div>
              </a>
            </div>
            <div class="tags" v-if="detail.tags">
              <div class="tag" v-for="(tag, i) in detail.tags" :key="`tag${i}`">
                {{tag.trim()}}
              </div>
            </div>
          </div>
          <div class="supportForm" v-if="1>2">
            <div class="donationBox" v-if="donations.length > 0"
              :style="{'margin-top': `${donationTop}px`}" :class="{st1: st === 1}">
              <div v-if="donationSuccess" class="donationSuccess">
                <div class="success-animation">
                  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"><circle class="checkmark__circle"
                    cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
                    fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
                </div>
                <h4>Terima kasih</h4>
                <p>Terima kasih telah berdonasi di Sahabat ICW</p>
              </div>
              <div v-else-if="st === 1">
                <h4>Dukung program ini</h4>
                <div class="backBtn" v-on:click="st = 0"></div>
                <div class="fieldGroup" v-for="(item, i) in donations[rdIdx].fields"
                  :key="`dfield${i}`"
                  :class="{hasError: item.error}">
                  <div class="fieldCnt">
                    <label>{{item.label}}<span v-if="item.isRequired">*</span></label>
                    <input type="text" class="field" :placeholder="item.placeholder"
                      v-if="item.type === 'text'" v-model="item.model"
                      v-on:input="item.error = null">
                    <input type="date" class="field" :placeholder="item.placeholder"
                      v-else-if="item.type === 'date'" v-model="item.model"
                      v-on:input="item.error = null">
                    <textarea rows="3" class="field" :placeholder="item.placeholder"
                      v-else-if="item.type === 'textarea'" v-model="item.model"
                      v-on:input="item.error = null"></textarea>
                    <div class="fieldError" v-if="item.error">{{item.error}}</div>
                  </div>
                </div>
                <div class="fieldGroup hasCheckbox">
                  <div class="checkCnt" v-on:click="anonim = !anonim">
                    <div class="checkbox" :class="{checked: anonim}"></div>
                    Jangan tampilkan nama saya di dalam daftar donasi
                  </div>
                </div>
                <div class="consent" v-if="tncUri">Dengan menekan tombol Kirimkan Donasi
                  kamu telah setuju dengan <a :href="tncUri">Syarat dan Ketentuan</a>
                  Sahabat ICW.</div>
              </div>
              <div v-else>
                <h4>Dukung program ini</h4>
                <div class="fieldGroup">
                  <div class="fieldCnt">
                    <label>Donasi Untuk</label>
                    <div class="donation" v-on:click.stop="donationOpen = !donationOpen;
                      openDonationSelector = false;">
                      <div class="donationImg" v-if="donations[rdIdx].headerMedia"
                        :style="{'background-image': `url(${donations[rdIdx]
                        .headerMedia.imageSm})`}"></div>
                      <div class="donationImg noImg" v-else></div>
                      <h4>{{donations[rdIdx].title}}</h4>
                      <p>{{donations[rdIdx].description}}</p>
                      <a :href="`/donasi/${donations[rdIdx].code}`"
                        v-on:click.stop="doNothing">Selengkapnya</a>
                    </div>
                    <div class="donationDd" v-on:click.stop="doNothing" v-if="donationOpen">
                      <div class="donation" v-for="(item, i) in donations" :key="`dnt${i}`"
                        v-on:click.stop="rdIdx = i; donationOpen = false;">
                        <div class="donationImg" v-if="item.headerMedia"
                          :style="{'background-image': `url(${item.headerMedia.imageSm})`}"></div>
                        <div class="donationImg noImg" v-else></div>
                        <h4>{{item.title}}</h4>
                        <p>{{item.description}}</p>
                        <a :href="`/donasi/${item.code}`"
                          v-on:click.stop="doNothing">Selengkapnya</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fieldGroup">
                  <div class="fieldCnt">
                    <label>Nominal Donasi</label>
                    <div class="ddCnt">
                      <div class="theDd"
                        v-on:click.stop="openDonationSelector = !openDonationSelector">
                        <span v-if="customAmount">Masukan nominal</span>
                        <span v-else>Rp {{amount.toLocaleString('id')}}</span></div>
                      <div class="dd" v-if="openDonationSelector">
                        <li v-on:click="selectAmount(20000)">Rp 20.000</li>
                        <li v-on:click="selectAmount(50000)">Rp 50.000</li>
                        <li v-on:click="selectAmount(150000)">Rp 150.000</li>
                        <li v-on:click="selectAmount(200000)">Rp 200.000</li>
                        <li v-on:click="customAmount = true">Masukan nominal</li>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fieldGroup" :class="{hasError: customAmountErr}"
                  v-if="customAmount">
                  <div class="fieldCnt hasPrefix">
                    <input type="text" class="field" placeholder="Masukan nominal"
                      v-model="amount" v-on:input="customAmountErr = false">
                    <div class="prefix">Rp</div>
                  </div>
                  <div class="fieldError" v-if="customAmountErr">
                    Mohon masukan nominal donasi
                  </div>
                </div>
                <div class="consent" v-if="tncUri">Dengan menekan tombol Kirimkan Donasi
                  kamu telah setuju dengan <a :href="tncUri">Syarat dan Ketentuan</a>
                  Sahabat ICW.</div>
              </div>
              <button class="btn primary" v-if="!donationSuccess"
                v-on:click="donateNow">Kirimkan Donasi</button>
            </div>
          </div>
        </div>

        <div class="articleShareSpacer" :class="{hidden: shareHidden}"
          v-if="detail && detail.type === 'article'"></div>
        <div class="articleShare" :style="{top: `${shareTop}px`}" :class="{hidden: shareHidden}"
          v-if="detail && detail.type === 'article'">
          <h4>Share</h4>
          <div class="shareCnt">
            <a target="_balnk"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
              <a href='${shareUri}'>${detail.title}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>
        <div ref="endArticle"></div>
      </div>
    </div>
    <div class="newsDetailPage media" v-else>
      <div class="previewInfo" :class="{scrolled: scrolled}" v-if="detail.status !== 'published'">
        <img src="../assets/private.png">
        This is preview content, not available for public viewer.
      </div>
      <div class="articleDetail">
        <div class="articleHeader">
          <div class="ahL">
            <div class="breadcrumb">
              <router-link to="/"
                class="bc">Home</router-link>
              <span class="dv">/</span>
              <router-link to="/publication"
                class="bc">Publication</router-link>
              <span class="dv">/</span>
              <span class="bc">{{detail.title}}</span>
            </div>
            <h2 class="articleTitle">{{detail.title}}</h2>
            <div class="publishTime">
              <span class="category" v-if="detail.parent">{{detail.parent.name}}</span>
              <span class="bull">&bull;</span>
              {{detail.publishDate | moment('MMM YYYY')}}
              <span class="bull">&bull;</span>
              340 views
            </div>
          </div>
          <div class="ahR">
            <div class="articleAction share" v-on:click="share">Bagikan</div>
            <div class="articleAction download" v-on:click="download"
              v-if="detail.type === 'video'
              && detail.media.mimetype !== 'video/youtube'">Download</div>
            <a :href="detail.media.pdf" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'pdf'">Download</a>
            <a :href="detail.media.audio" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'audio'">Download</a>
            <div class="moreCnt">
              <button class="articleAction moreBtn"
                v-on:click.stop="moreOpen = !moreOpen">Options</button>
              <div class="moreMenu" v-if="moreOpen" v-on:click.stop="doNothing">
                <div class="articleAction share" v-on:click="share">Bagikan</div>
                <div class="articleAction download" v-on:click="download"
                  v-if="detail.type === 'video'">Download</div>
                <a :href="detail.media.pdf" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'pdf'">Download</a>
                <a :href="detail.media.audio" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'audio'">Download</a>
              </div>
            </div>
          </div>
        </div>
        <div class="protected" v-if="detail.protected">
          <img src="../assets/padlock.png">
          <h4>Akses Terbatas</h4>
          <div v-if="detail.password">
            <p>Masukan password untuk membuka konten ini</p>
            <form v-on:submit.prevent="getData">
              <div class="inputCnt">
                <div class="privateIcon"></div>
                <input type="password" placeholder="• • • •"
                  v-model="pwd">
                <button class="submitBtn" v-on:click="getData"></button>
              </div>
            </form>
          </div>
          <p v-else>Kamu tidak punya hak akses untuk membuka konten ini</p>
        </div>
        <div v-else>
          <div class="articleContent" v-if="detail.type === 'pdf'">
            <div id="dfCnt"></div>
          </div>
          <div class="articleContent image gallery" v-else-if="detail.type === 'gallery'">
            <div class="theImg" :style="{'background-image':
              `url(${detail.gallery[gi].imageMd})`}" v-on:click="previewImgObject"></div>
            <div class="galleryNav p" v-if="gi > 0"
              v-on:click.stop="gi -= 1"></div>
            <div class="galleryNav n" v-if="gi < detail.gallery.length - 1"
              v-on:click.stop="gi += 1"></div>
            <div class="galleryPager" v-on:click.stop="doNothing">
              <div class="pagerItem" v-for="(item, i) in detail.gallery" :key="i"
                v-on:click.stop="gi = i"
                :class="{active: i === gi}"></div>
            </div>
            <div class="downloadCnt">
              <a :href="detail.gallery[gi].imageLg" target="_blank" download
                class="btn download" v-on:click="download">Download</a>
              <button class="btn openSlide" v-on:click="previewImgObject"></button>
            </div>
          </div>
          <div class="articleContent video" v-else-if="detail.type === 'video'
            && detail.media && detail.media.mimetype === 'video/youtube'">
            <iframe :src="detail.embedUri" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media;
              gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div class="articleContent video" v-else-if="detail.type === 'video'">
            <VuePlyr ref="video" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent audio" v-else-if="detail.type === 'audio'">
            <VuePlyr ref="audio" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent html" v-else-if="detail.type === 'html'"
            v-html="detail.htmlContent.html"></div>
          <div class="attachmentCnt" v-if="detail.attachments.length > 0">
            <h4 class="aTitle">Attachment</h4>
            <a :href="att.uri" class="attachmentItem"
              v-for="(att, i) in detail.attachments" :key="`att${i}`">
              <div class="attachmentIcon" v-if="att.type === 'image'"
                :style="{'background-image': `url(${att.imageTh})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else-if="att.type === 'video'"
                :style="{'background-image': `url(${att.mainThumb})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else :class="att.type"></div>
              <h4>{{att.name}}</h4>
              <div class="aIcon download"></div>
            </a>
          </div>
        </div>
        <div class="content">
          <div class="label" v-if="detail.tags.length > 0">
            <a :href="`/${detail.parent.code}?q=${escape(tag)}`"
              class="labelItem" v-for="(tag, i) in detail.tags"
              :key="`dt${i}`">{{tag}}</a>
          </div>
          <article class="articleContent detail-wrapper" v-html="detail.content"></article>
          <div class="attachmentCnt" v-if="detail.attachments.length > 0">
            <h4 class="aTitle">Attachment</h4>
            <a :href="att.uri" class="attachmentItem"
              v-for="(att, i) in detail.attachments" :key="`att${i}`">
              <div class="attachmentIcon" v-if="att.type === 'image'"
                :style="{'background-image': `url(${att.imageTh})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else-if="att.type === 'video'"
                :style="{'background-image': `url(${att.mainThumb})`}"
                :class="att.type"></div>
              <div class="attachmentIcon" v-else :class="att.type"></div>
              <h4>{{att.name}}</h4>
              <div class="aIcon download"></div>
            </a>
          </div>
          <div class="articleShare articleShareStatic">
            <h4>Share</h4>
            <div class="shareCnt">
              <a target="_balnk"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                <i class="fa fa-facebook fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
                <i class="fa fa-twitter fa-fw"></i>
              </a>
              <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
                <i class="fa fa-whatsapp fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
                <i class="fa fa-telegram fa-fw"></i>
              </a>
              <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
                <a href='${shareUri}'>${detail.title}</a>`">
                <i class="fa fa-email fa-fw"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cnt cntArticle">
      <div class="related">
        <div v-if="related.length > 0">
          <h4>Artikel terkait</h4>
          <div class="relatedCnt">
            <div class="relatedSc" :class="{not4: related.length < 4}">
              <div class="relatedItem" v-for="(item, i) in related"
                :key="`rlt${i}`">
                <a :href="item.linkUrl" target="_blank" v-if="item.type === 'link'">
                  <div class="relatedImg" v-if="item.thumb"
                    :style="{'background-image': `url(${item.thumb})`}"></div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                </a>
                <a :href="`/article/${item.code}`" v-else>
                  <div class="relatedImg" v-if="item.thumb"
                    :style="{'background-image': `url(${item.thumb})`}"></div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ShareDialog ref="shareDialog"/>
    <OtherPaymentDialog ref="otherPaymentDialog"/>
    <DownloadSelector ref="downloadSelector"/>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

// import { api as viewerApi } from 'v-viewer';
// import 'viewerjs/dist/viewer.css';

import Header from '@/components/Header.vue';
import OtherPaymentDialog from '@/components/OtherPaymentDialog.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import DownloadSelector from '@/components/DownloadSelector.vue';

export default {
  name: 'home',
  components: {
    Header,
    VuePlyr,
    OtherPaymentDialog,
    ShareDialog,
    DownloadSelector,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      detail: null,
      moreOpen: false,
      related: [],
      products: [],
      donationsRlt: [],
      gi: 0,
      loadingDownload: false,
      shareTop: null,
      shareHidden: false,
      donationTop: 0,
      currentPage: 0,
      shareUri: '',

      /**
       * Donation
       *
       */
      st: 0,
      donationOpen: false,
      donationSuccess: false,
      donations: [],
      rdIdx: 0,
      tncUri: null,
      anonim: false,
      amount: 50000,
      customAmount: false,
      customAmountErr: false,
      openDonationSelector: false,
    };
  },
  methods: {
    doNothing() {},
    selectAmount(amount) {
      this.amount = amount;
      this.customAmount = false;
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      this.openDonationSelector = false;
      this.donationOpen = false;
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      const currentScrollPos = window.pageYOffset;
      const aHRect = this.$refs.endArticle.getBoundingClientRect();
      let stSpace = (60 + 96 + 140) - 96;
      let dnSpace = 60 + 96;
      if (window.innerWidth > 1480) {
        stSpace += 560;
        dnSpace += 560;
      } else if (window.innerWidth > 1260) {
        stSpace += 500;
        dnSpace += 500;
      } else {
        stSpace += 460;
        dnSpace += 460;
      }
      if (aHRect.top > 420 && currentScrollPos >= stSpace) {
        this.shareTop = 100 + currentScrollPos;
      } else if (aHRect.top > 420) {
        this.shareTop = stSpace + 100;
      }
      if (aHRect.top > 740 && currentScrollPos >= stSpace - 140) {
        this.donationTop = currentScrollPos - (stSpace - 140);
      } else if (aHRect.top > 740) {
        this.donationTop = 0;
      }
      this.shareHidden = (aHRect.top <= window.innerHeight);
    },
    embed() {
      this.moreOpen = false;
      this.$refs.embedDialog.open(this.detail);
    },
    share() {
      this.moreOpen = false;
      this.$refs.shareDialog.open(this.detail, {
        page: this.currentPage,
        session: this.sessionId,
      });
    },
    donateNow() {
      if (this.st === 1) {
        if (!this.amount || this.amount === '' || parseInt(this.amount, 10) < 1) {
          this.customAmountErr = true;
          return;
        }
        // eslint-disable-next-line
        for (const field of this.donations[this.rdIdx].fields) {
          if ((!field.model || field.model === '') && field.isRequired) {
            field.error = `Mohon masukan ${field.label}`;
            return;
          }
        }
        this.$refs.otherPaymentDialog.open({
          type: 'donation',
          amount: this.amount,
          data: {
            formData: this.donations[this.rdIdx].fields,
            formId: this.donations[this.rdIdx].id,
            amount: this.amount,
            anonim: this.anonim,
          },
        }, () => {
          window.history.replaceState({}, this.detail.code, `/article/${this.detail.code}`);
          if (this.$refs.otherPaymentDialog.success) {
            this.donationSuccess = true;
          }
        });
      } else {
        if (!this.amount || this.amount === '' || parseInt(this.amount, 10) < 1) {
          this.customAmountErr = true;
          return;
        }
        this.st = 1;
      }
    },
    download() {
      this.moreOpen = false;
      if (this.detail.type === 'video') {
        this.$refs.downloadSelector.open(this.detail.media, this.sessionId);
      }
    },
    downloadGallery() {
      if (this.loadingDownload) return;
      this.loadingDownload = true;
      this.$http.get(this.$config.uri(`content/${this.detail.id}/download/gallery`)).then((r) => {
        const link = document.createElement('a');
        link.setAttribute('download', '');
        link.href = r.data.fileUri;
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loadingDownload = false;
      });
    },
    previewImgObject() {
      const viewerOptions = {
        url: 'imageLg',
        title: false,
        movable: false,
        zoomOnWheel: false,
        slideOnTouch: true,
      };
      if (this.detail.type === 'gallery') {
        viewerApi({
          options: viewerOptions,
          images: this.detail.gallery,
        });
      } else {
        viewerApi({
          options: viewerOptions,
          images: [detail.imageMd],
        });
      }
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const { code } = this.$route.params;
    const { id } = this.$route.params;
    // eslint-disable-next-line
    const sign = this.$route.query._sign;
    const uri = (code) ? `article/${code}` : `article/detail/${id}?sign=${sign}`;
    this.$http.get(this.$config.uri(uri)).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display error
        return;
      }
      this.detail = r.data.data;
      this.shareUri = `${this.$config.appUri}article/${this.detail.code}`;
      document.title = `${this.detail.title} - ${this.$config.appName}`;
      const rltUri = `article/all?parentId=${this.detail.parent.id}&related=${this.detail.id}&limit=4`;
      this.$http.get(this.$config.uri(rltUri)).then((rRlt) => {
        this.related = (rRlt.data.status === 200) ? rRlt.data.data : [];
      });
      this.$http.get(this.$config.uri('product/all?limit=4')).then((rPrd) => {
        this.products = (rPrd.data.status === 200) ? rPrd.data.data : [];
      });
      this.$http.get(this.$config.uri('donation/all?limit=3')).then((rDnt) => {
        this.donationsRlt = (rDnt.data.status === 200) ? rDnt.data.data : [];
      });

      if (this.detail.type === 'pdf') {
        setTimeout(() => {
          let heightOff = 0;
          const winWidth = $(window).width();
          if (winWidth > 980) heightOff = 183;
          else heightOff = 165;
          const fbH = $(window).height() - heightOff;
          $('#dfCnt').flipBook(this.detail.media.pdf, {
            backgroundColor: '#F1F6FF',
            scrollWheel: false,
            height: fbH,
            hideControls: 'share,download',
            onFlip: (fb) => {
              this.currentPage = fb.currentPage();
            },
            onReady: (fb) => {
              if (this.$route.query.p) {
                setTimeout(() => {
                  fb.gotoPage(this.$route.query.p);
                }, 1200);
              }
            },
          });
        }, 500);
      } else if (this.detail.type === 'video') {
        if (this.detail.media && this.detail.media.mimetype === 'video/youtube') return;
        const src = [];
        if (this.detail.media.vid1080p) src.push({ src: this.detail.media.vid1080p, type: 'video/mp4', size: 1080 });
        if (this.detail.media.vid720p) src.push({ src: this.detail.media.vid720p, type: 'video/mp4', size: 720 });
        if (this.detail.media.vid480p) src.push({ src: this.detail.media.vid480p, type: 'video/mp4', size: 480 });
        if (this.detail.media.vid360p) src.push({ src: this.detail.media.vid360p, type: 'video/mp4', size: 360 });
        setTimeout(() => {
          const v = this.$refs.video.player;
          v.source = { type: 'video', title: this.detail.title, sources: src };
          v.play();
        });
      } else if (this.detail.type === 'audio') {
        const src = [{ src: this.detail.media.audio, type: this.detail.media.mimetype }];
        setTimeout(() => {
          const v = this.$refs.audio.player;
          v.source = { type: 'audio', title: this.detail.title, sources: src };
          v.play();
        });
      } else if (this.detail.type === 'article') {
        this.$http.get(this.$config.uri('article/tnc')).then((rTnc) => {
          this.tncUri = (rTnc.data.status === 200) ? rTnc.data.uri : null;
        });
        this.$http.get(this.$config.uri('donation/all')).then((rd) => {
          if (rd.data.status !== 200) {
            // Display error
            return;
          }
          this.donations = rd.data.data;
        });
        // setTimeout(() => {
        //   ReadingTime(270, '', 'mins read', '', 'less than a minutes read');
        // }, 200);
      }
    });
  },
};
</script>

<style lang="scss">
.articleContent.articleDetail{
  padding-top: 0;
  font-size: 18px;
  line-height: 1.5;
  @media (max-width: 1480px) {
    font-size: 17px;
  }
  p{
    margin: 0;
  }
  blockquote{
    font-size: 26px;
    line-height: 1.3;
    border-left: #ddd 4px solid;
    position: relative;
    margin: 26px 0;
    padding-bottom: 6px;
    color: #767676;
    padding-left: 50px;
    padding-left: 30px;
    &:before{
      content: "\"";
      font-size: 80px;
      position: absolute;
      left: 14px; top: -14px;
      display: none;
    }
  }
  p.caption{
    margin: -14px 0 20px 10px;
    font-size: 15px;
    line-height: 1.4;
    min-height: 22px;
  }

  p{
    margin: 0;
  }
  iframe.theMedia{
    height: 420px;
    border: none;
    @media (max-width: 700px){
      height: 200px;
    }
  }
  .theMedia{
    display: block;
    margin: 20px 0;
    width: 100%;
    border-radius: 5px;
    position: relative;
    z-index: 3;
    &.md-wide{
      width: calc(100% + 200px);
      margin: 20px -100px;
      @media (max-width: 974px) {
        width: calc(100% + 100px);
        margin: 20px -50px;
      }
      @media (max-width: 874px) {
        width: calc(100% + 40px);
        margin: 20px -20px;
        border-radius: 0;
      }
    }
  }
}
.articleDetail{
  padding: 40px 0 40px;
  // min-height: calc(100vh - 182px);
  min-height: 400px;
  .content{
    max-width: 750px;
    margin: 0 auto;
    @media (max-width: 960px) {
      max-width: none;
      margin: 0 20px;
    }
    .articleTitle{
      font-size: 40px;
      margin: 0;
      line-height: 1.2;
      margin-bottom: 20px;
      font-weight: 600;
    }
    .articleContent{
      font-size: 20px;
      line-height: 1.6;
      blockquote{
        font-size: 26px;
        line-height: 1.3;
        border-left: #ddd 4px solid;
        position: relative;
        margin: 26px 0;
        padding-bottom: 6px;
        color: #767676;
        padding-left: 50px;
        padding-left: 30px;
        &:before{
          content: "\"";
          font-size: 80px;
          position: absolute;
          left: 14px; top: -14px;
          display: none;
        }
      }
      p.caption{
        margin: -14px 0 20px 10px;
        font-size: 15px;
        line-height: 1.4;
        min-height: 22px;
      }

      p{
        margin: 0;
      }
      iframe.theMedia{
        height: 420px;
        border: none;
        @media (max-width: 700px){
          height: 200px;
        }
      }
      .theMedia{
        display: block;
        margin: 20px 0;
        width: 100%;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &.md-wide{
          width: calc(100% + 200px);
          margin: 20px -100px;
          @media (max-width: 974px) {
            width: calc(100% + 100px);
            margin: 20px -50px;
          }
          @media (max-width: 874px) {
            width: calc(100% + 40px);
            margin: 20px -20px;
            border-radius: 0;
          }
        }
      }
    }
  }
  @media (max-width: 700px) {
    // padding: 50px 0 30px;
    .content{
      .articleTitle{
        font-size: 30px;
        line-height: 1.3;
        margin-bottom: 10px;
      }
      .articleContent{
        font-size: 18px;
        line-height: 1.6;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.cnt.cntArticle{
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    max-width: 1080px;
  }
  @media (max-width: 1260px) {
    max-width: none;
    margin: 0 30px;
  }
  @media (max-width: 960px) {
    margin: 0 20px;
  }
}
.articleShareSpacer{
  @media (max-width: 1260px) {
    height: 62px;
    &.hidden{
      height: 0;
    }
  }
}
.articleShare{
  position: absolute;
  // 560 header img, 96 header, 60 donation spacing
  top: calc(560px + 60px + 96px + 140px);
  left: calc(((100% - 760px) / 2) - 80px);
  padding: 0 10px 5px;
  background-color: #fff;
  border-radius: 5px;
  @media (max-width: 1480px) {
    top: calc(500px + 60px + 96px + 140px);
  }
  h4{
    margin: 0 0 10px;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: #767676;
  }
  a{
    display: block;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-twitter.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  &.articleShareStatic{
    position: static;
    margin: 20px 0 0;
    padding: 10px 0;
    border: none;
    display: flex;
    align-items: center;
    @media (max-width: 680px) {
      margin-left: -4px;
    }
    h4{
      margin: 0 10px 0 0;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .shareCnt{
      display: flex;
    }
  }
  @media (max-width: 940px) {
    position: fixed;
    display: flex;
    left: 0; right: 0;
    top: auto !important; bottom: 0;
    background-color: #fff;
    transform: none;
    border-radius: 0;
    padding: 10px 30px;
    z-index: 991;
    border-top: #eee 1px solid;
    margin: 0;
    align-items: center;
    @media (max-width: 960px) {
      padding: 10px 20px;
    }
    &.hidden{
      position: static;
      border-bottom: #eee 1px solid;
      margin: 0 -30px;
      @media (max-width: 960px) {
        margin: 0 -20px;
      }
    }
    h4{
      text-align: left;
      margin: 0;
      margin-right: 20px;
      font-size: 17px;
      text-transform: none;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .shareCnt{
      display: flex;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  }
  @media (max-width: 680px) {
    padding-left: 10px;
  }
}

.newsDetailPage{
  margin-top: 96px;
}
.previewInfo{
  // background-color: yellow;
  // background-color: rgba(255, 255, 0, .86);
  background-image: linear-gradient(45deg, yellow, transparent);
  color: #000;
  padding: 10px 20px;
  position: fixed;
  top: 96px; left: 0;
  width: 100%;
  max-width: 960px;
  z-index: 9;
  transition: all .3s ease;
  display: flex;
  align-items: center;
  &.scrolled{
    top: 76px;
  }
  img{
    height: 20px;
    margin-top: -3px;
    margin-right: 10px;
  }
}
.newsHeader{
  height: 560px;
  background-color: #ccc;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  @media (max-width: 1480px) {
    height: 500px;
  }
  @media (max-width: 1260px) {
    height: 460px;
  }
  @media (max-width: 680px) {
    height: 240px;
  }
  &.noImg{
    background-image: url(../assets/image-black.png);
    background-size: 64px auto;
    opacity: .36;
  }
}
.supportCnt{
  // display: flex;
  @media (max-width: 1140px) {
    display: block;
  }
  .supportInfo{
    // width: calc(100% - 440px);
    max-width: 760px;
    box-sizing: border-box;
    padding: 40px 0;
    // padding-right: 60px;
    margin: 0 auto;
    @media (max-width: 1480px) {
      padding-right: 20px;
    }
    @media (max-width: 1140px) {
      padding-right: 0;
      width: auto;
    }
    .timestampCnt{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding-bottom: 20px;
      font-size: 15px;
      color: #444;
      .category{
        background-color: #035fae;
        border-radius: 50px;
        color: #fff;
        font-weight: 600;
        font-size: 14px;
        padding: 6px 14px;
        margin-right: 16px;
        white-space: nowrap;
        margin-bottom: 5px;
      }
      .timestamp{
        margin-bottom: 5px;
      }
    }
    .reading-time{
      margin-left: 16px;
      color: #767676;
    }
    .reading-time__word-count{
      display: none;
    }
    h2{
      margin: 0 0 20px -1px;
      font-size: 48px;
      line-height: 1.3;
      @media (max-width: 960px) {
        font-size: 42px;
      }
      @media (max-width: 680px) {
        font-size: 30px;
      }
    }
    p{
      margin: 0 0 20px;
      font-size: 19px;
      line-height: 1.7;
    }
    .tags{
      display: flex;
      .tag{
        color: #035fae;
        font-weight: 600;
        font-size: 14px;
        margin-right: 10px;
      }
    }
  }
  .supportForm{
    padding: 60px 0 120px 60px;
    width: 440px;
    box-sizing: border-box;
    position: relative;
    @media (max-width: 1140px) {
      display: none;
    }
    .donationSuccess{
      text-align: center;
      padding: 40px 20px;
      margin-top: 20px;
      border-radius: 5px;
      .success-animation{
        margin-bottom: 24px;
        .checkmark{
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: block;
          stroke-width: 2;
          stroke: #4bb71b;
          stroke-miterlimit: 10;
          box-shadow: inset 0px 0px 0px #4bb71b;
          animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
          margin: 0 auto;
        }
        .checkmark__circle{
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          stroke-width: 2;
          stroke-miterlimit: 10;
          stroke: #4bb71b;
          fill: #f9e503;
          animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }
        .checkmark__check{
          transform-origin: 50% 50%;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
        @keyframes stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.1, 1.1, 1);
          }
        }
        @keyframes fill {
          100% {
            box-shadow: inset 0px 0px 0px 30px #4bb71b;
          }
        }
      }
      h4{
        margin: 0 0 6px;
      }
    }
    .donationBox{
      background-color: #fae502;
      padding: 26px 26px;
      box-sizing: border-box;
      border-radius: 10px;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, .2);
      position: absolute;
      top: 60px; right: 0; left: 60px;
      .backBtn{
        width: 40px; height: 40px;
        border-radius: 50%;
        margin-bottom: 10px;
        margin: -6px 0 10px;
        background-image: url(../assets/back-arrow-black.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0, 0, 0, .1);
        }
      }
      &.st1{
        max-height: calc(100vh - 160px);
        overflow-y: auto;
      }
      h4{
        font-size: 22px;
        margin: 0 0 16px;
      }
      .fieldGroup.hasCheckbox{
        margin-bottom: 16px;
        .checkCnt{
          padding-left: 30px;
          font-size: 15px;
          cursor: pointer;
          .checkbox{
            border-color: #444;
            left: 0; top: 12px;
          }
        }
      }
      .fieldGroup{
        margin-bottom: 16px;
        label{
          color: #444;
        }
        .field{
          padding-top: 9px;
          padding-bottom: 7px;
        }
      }
      .consent{
        font-size: 14px;
        line-height: 1.3;
        margin-bottom: 16px;
      }
      .fieldCnt{
        position: relative;
        label{
          text-transform: uppercase;
          font-weight: 600;
          font-size: 13px;
          margin: 0 7px 6px;
          display: block;
        }
        .donation{
          background-color: #fff;
          padding: 12px 20px;
          border: #ccc 1px solid;
          border-radius: 5px;
          position: relative;
          padding-left: 108px;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
          }
          .donationImg{
            position: absolute;
            left: 12px; top: 12px; bottom: 12px;
            width: 80px;
            background-color: #ccc;
            border-radius: 5px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            &.noImg{
              background-image: url(../assets/image-black.png);
              background-size: 26px auto;
              opacity: .36;
            }
          }
          h4{
            font-size: 16px;
            font-weight: 600;
            margin: 0 0 2px;
          }
          p{
            margin: 0 0 2px;
            font-size: 14px;
            line-height: 1.2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          a{
            font-size: 14px;
            display: inline-block;
            position: relative;
            &:before{
              display: none;
              content: "";
              position: absolute;
              top: 2px; bottom: 0; right: -24px; width: 20px;
              background-image: url(../assets/arrow-next-black.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
        }
        .donationDd{
          position: absolute;
          left: 0; right: 0; top: 100%;
          z-index: 3;
          background-color: #fff;
          border-radius: 5px;
          overflow: hidden;
          box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
          // padding: 10px 0;
          .donation{
            border: none;
            border-radius: 0;
            box-shadow: none;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
        .ddCnt{
          position: relative;
          .theDd{
            font-weight: 500;
            background-color: #fff;
            padding: 10px 14px;
            width: 100%;
            display: block;
            box-sizing: border-box;
            border-radius: 5px;
            border: #ccc 1px solid;
            font-size: 15px;
            cursor: pointer;
            position: relative;
            transition: all .3s ease;
            &:hover{
              box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
            }
            &:before{
              content: "";
              position: absolute;
              right: 14px; top: 12px;
              width: 16px; height: 16px;
              background-image: url(../assets/down-arrow.png);
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          .dd{
            position: absolute;
            top: 100%; left: 0; right: 0;
            background-color: #fff;
            z-index: 9;
            box-shadow: 0 2px 10px rgba(0, 0, 0, .2);
            padding: 10px 0;
            border-radius: 5px;
            li{
              list-style: none;
              padding: 8px 14px;
              font-weight: 500;
              cursor: pointer;
              transition: all .3s ease;
              font-size: 15px;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
      }
      .btn.primary{
        width: 100%;
        background-color: #ff0400;
        border-radius: 50px;
        &:hover{
          background-color: #cc0300;
        }
      }
    }
  }
}

.newsDetailPage.media{
  .articleDetail{
    .content{
      margin-top: 40px;
      @media (max-width: 680px) {
        margin-top: 20px;
      }
    }
  }
  .pagePubDetail{
    background-color: #fff;
  }
  .preview{
    position: fixed;
    z-index: 991;
    left: 0; right: 0; bottom: 0;
    padding: 10px 0;
    text-align: center;
    background-color: yellow;
    color: #222;
  }
  #dfCnt{
    background-color: #f5f5f5;
    height: calc(100vh - 64px);
    @media (max-width: 1480px) {
      height: calc(100vh - 60px);
    }
  }
  .articleContent{
    &.html{
      // max-width: 1180px;
      // margin: 0 auto;
      overflow: hidden;
    }
    &.image{
      height: 640px;
      position: relative;
      background-color: #444;
      min-height: calc(80vh);
      @media (max-width: 760px) {
        height: 520px;
      }
      @media (max-width: 680px) {
        height: 360px;
        min-height: 0;
      }
      .theImg{
        position: absolute;
        left: 40px; top: 40px; right: 40px; bottom: 40px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      &.gallery{
        .theImg{
          bottom: 80px;
        }
        .downloadCnt{
          position: absolute;
          left: 0; right: 0; bottom: 10px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 4;
          .btn{
            border: none;
            background-color: transparent;
            color: #fff;
            height: 40px;
            transition: all .3s ease;
            border-radius: 50px;
            margin: 0 4px;
            display: inline-block;
            font-weight: normal;
            font-size: 15px;
            outline: 0;
            &:hover{
              background-color: #222;
            }
            &.download{
              padding: 0 20px;
              line-height: 40px;
              padding-left: 54px;
              position: relative;
              background-color: #333;
              &:hover{
                background-color: #222;
              }
              &:before{
                content: "";
                position: absolute;
                left: 20px; top: 7px;
                width: 20px; height: 20px;
                background-size: 20px auto;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(../assets/download-white.png);
              }
            }
            &.openSlide{
              width: 40px;
              background-size: 28px auto;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url(../assets/maximize-white.png);
            }
          }
        }
      }
      .galleryNav{
        position: absolute;
        top: 50%;
        width: 30px; height: 30px;
        background-color: #fff;
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        margin-top: -15px;
        border-radius: 50%;
        opacity: .65;
        cursor: pointer;
        transition: all .3s ease;
        z-index: 3;
        &:hover{
          opacity: 1;
        }
        &.p{
          left: 30px;
          background-image: url(../assets/left-arrow.png);
          @media (max-width: 680px) {
            left: 15px;
          }
        }
        &.n{
          right: 30px;
          background-image: url(../assets/right-arrow.png);
          @media (max-width: 680px) {
            right: 15px;
          }
        }
      }
      .galleryPager{
        position: absolute;
        bottom: 60px;
        display: flex;
        left: 0; right: 0;
        justify-content: center;
        .pagerItem{
          width: 8px; height: 8px;
          background-color: #ccc;
          border-radius: 50%;
          margin: 0 2px;
          cursor: pointer;
          &.active{
            background-color: #0057d8;
          }
        }
      }
    }

    &.video{
      height: 640px;
      position: relative;
      background-color: #000;
      @media (max-width: 1200px) {
        height: 60vw;
      }
      iframe{
        width: 100%; height: 100%;
      }
    }
    &.audio{
      border: #eee 1px solid;
      max-width: 1180px;
      margin: 0 auto;
      @media (max-width: 1300px) {
        max-width: 1140px;
      }
      @media (max-width: 1220px) {
        margin: 0 20px;
      }
      @media (max-width: 680px) {
        margin: 0 16px;
      }
    }
  }
  .sectionTitle{
    font-size: 32px;
    line-height: 1.3;
    margin: 0 auto 10px;
    max-width: 1180px;
    a{
      font-size: 17px;
      font-weight: 600;
      display: inline-block;
      border: #002f5f 1px solid;
      padding: 6px 10px 5px;
      border-radius: 2px;
      margin-top: 0px;
      float: right;
      transition: all .3s ease;
      &:hover{
        background-color: #002f5f;
        color: #fff;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      }
    }
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px 10px;
    }
    @media (max-width: 680px) {
      margin: 0 16px 10px;
      font-size: 20px;
    }
  }
  .articleDetail{
    padding: 12px 0 60px;
    @media (max-width: 680px) {
      padding-top: 0;
      padding-bottom: 20px;
    }
    .articleHeader{
      display: flex;
      max-width: 1180px;
      margin: 0 auto;
      padding-bottom: 20px;
      position: relative;
      @media (max-width: 1300px) {
        max-width: 1140px;
      }
      @media (max-width: 1220px) {
        margin: 0 20px;
      }
      @media (max-width: 680px) {
        margin: 0 16px;
        display: block;
        padding-bottom: 8px;
      }
      .ahL{
        margin-right: auto;
        .breadcrumb{
          font-size: 14px;
          white-space: nowrap;
          font-family: 'League Spartan', sans-serif;
          display: flex;
          @media (max-width: 980px){
            display: none;
          }
          .bc{
            color: #444;
            margin-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 160px;
          }
          a.bc{
            color: #002f5f;
          }
          .dv{
            margin-right: 10px;
            color: #ccc;
          }
        }
        .articleTitle{
          font-size: 30px;
          margin: 10px 0 4px;
          @media (max-width: 680px) {
            font-size: 22px;
            margin: 0 0 6px;
          }
        }
        .publishTime{
          color: #767676;
          @media (max-width: 680px) {
            font-size: 14px;
          }
          .bull{
            margin: 0 12px 0 10px;
            color: #999;
          }
          .category{
            font-weight: 500;
            color: #fff;
            background-color: #035fae;
            padding: 3px 12px 4px;
            font-size: 14px;
            border-radius: 50px;
          }
        }
      }
      .ahR{
        display: flex;
        align-items: center;
        @media (max-width: 680px) {
          margin: 10px 0 4px;
        }
        .articleAction{
          margin-left: 10px;
          position: relative;
          padding: 10px 16px 7px;
          padding-left: 46px;
          border-radius: 50px;
          cursor: pointer;
          transition: all .3s ease;
          background-color: #fff;
          // border: #eee 1px solid;
          color: #444;
          border: none;
          white-space: nowrap;
          font-family: 'League Spartan', sans-serif;
          font-size: 16px;
          font-weight: 400;
          line-height: 1;
          @media (max-width: 680px) {
            font-size: 15px;
            margin: 0;
            // margin-right: 10px;
            padding: 7px 14px 6px 34px;
          }
          &:hover{
            // background-color: #eee;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          &:before{
            width: 16px; height: 16px;
            content: "";
            position: absolute;
            left: 16px; top: 8px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              width: 14px; height: 14px;
              top: 7px; left: 10px;
            }
          }
          &.embed{
            &:before{
              background-image: url(../assets/coding.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              // display: block;
            }
          }
          &.share{
            &:before{
              background-image: url(../assets/share.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.download{
            &:before{
              background-image: url(../assets/download-icon.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.views{
            &:before{
              background-image: url(../assets/eye.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.moreBtn{
            padding-left: 40px;
            &:before{
              background-image: url(../assets/more-veritcal.png);
            }
          }
          &.buyNow{
            padding-left: 42px;
            background-color: #002f5f;
            border-color: #002f5f;
            color: #fff;
            @media (max-width: 680px) {
              padding-left: 34px;
            }
            &:hover{
              background-color: #014b96;
              border-color: #014b96;
            }
            &:before{
              width: 20px; height: 20px;
              top: 8px;
              background-image: url(../assets/bag-white.png);
              @media (max-width: 680px) {
                width: 18px; height: 18px;
                top: 6px;
              }
            }
          }
        }
        .moreCnt{
          position: relative;
          display: none;
          @media (max-width: 920px) {
            display: block;
          }
          @media (max-width: 680px) {
            display: none;
          }
          .moreMenu{
            position: absolute;
            right: 0; top: 100%;
            z-index: 9;
            background-color: #fff;
            padding: 10px 0;
            border-radius: 5px;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
            .articleAction{
              position: relative;
              padding: 12px 36px 10px;
              font-size: 16px;
              white-space: nowrap;
              padding-left: 58px;
              display: block;
              margin: 0;
              border-radius: 0;
              border: none;
              min-width: 80px;
              &:hover{
                background-color: #eee;
              }
              &:before{
                width: 18px; height: 18px;
                content: "";
                position: absolute;
                left: 24px; top: 9px;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                @media (max-width: 680px) {
                  width: 16px;
                  top: 5px;
                }
              }
              &.embed{
                &:before{
                  background-image: url(../assets/coding.png);
                }
              }
              &.share{
                &:before{
                  background-image: url(../assets/share.png);
                }
              }
              &.download{
                &:before{
                  background-image: url(../assets/download-icon.png);
                }
              }
              &.views{
                &:before{
                  background-image: url(../assets/eye.png);
                }
              }
            }
          }
        }
      }
    }
  }
  .protected{
    padding: 200px 0;
    text-align: center;
    background-color: #f5f5f5;
    img{
      opacity: .8;
      margin-bottom: 20px;
      height: 84px;
      opacity: .75;
    }
    h4{
      margin: 0 0 2px;
    }
    p{
      color: #767676;
      margin: 0;
    }
    .inputCnt{
      margin-top: 16px;
      position: relative;
      display: inline-block;
      width: 300px;
      .privateIcon{
        position: absolute;
        left: 8px; top: 8px;
        width: 30px; height: 30px;
        background-image: url(../assets/private.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .3;
      }
      button{
        position: absolute;
        width: 40px; height: 40px;
        border: none;
        border-radius: 50%;
        right: 4px; top: 4px;
        transition: all .3s ease;
        background-image: url(../assets/arrow-right-bold.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        opacity: .6;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
      }
      input{
        border-radius: 5px;
        border: #ccc 1px solid;
        padding: 10px 20px;
        text-align: center;
        font-size: 20px;
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

.attachmentCnt{
  padding-top: 20px;
  // margin-top: 20px;
  .aTitle{
    font-size: 20px;
    margin: 0 7px 10px;
  }
  .attachmentItem{
    position: relative;
    padding: 6px 10px;
    padding-right: 120px;
    background-color: #fff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    border: #f5f5f5 1px solid;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    color: #444;
    .attachmentIcon{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px; height: 26px;
      border-radius: 5px;
      background-color: #d9d6e4;
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/attachment.png);
      font-size: 13px;
      color: #fff;
      font-weight: 600;
      text-transform: uppercase;
      margin-right: 10px;
      &.pdf{
        background-color: #e21717;
        background-image: url(../assets/pdf-icon-white.png);
      }
      &.audio{
        background-image: url(../assets/musical-note-blue.svg);
      }
      &.image{
        background-size: cover;
      }
      &.video{
        background-size: cover;
      }
    }
    .aIcon{
      position: absolute;
      width: 30px; height: 30px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 12px auto;
      background-image: url(../assets/close.png);
      border-radius: 50%;
      top: 50%; right: 10px;
      margin-top: -15px;
      transition: background-color .3s ease;
      cursor: pointer;
      opacity: .7;
      &:hover{
        background-color: #ddd;
      }
      &.download{
        // right: 82px;
        background-image: url(../assets/download-o.png);
        background-size: 14px auto;
        opacity: 1;
      }
    }
    h4{
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 40px);
    }
    p{
      margin: 0;
      color: #767676;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
